import { render, staticRenderFns } from "./RecCard.vue?vue&type=template&id=88856c66&"
import script from "./RecCard.vue?vue&type=script&lang=js&"
export * from "./RecCard.vue?vue&type=script&lang=js&"
import style0 from "./RecCard.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports